import { render, staticRenderFns } from "./ProjectsOverview.vue?vue&type=template&id=0d92c84c"
import script from "./ProjectsOverview.vue?vue&type=script&lang=ts"
export * from "./ProjectsOverview.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsOverview.vue?vue&type=style&index=0&id=0d92c84c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports